function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1920v723H0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 656.422,
  y1: 757.389,
  x2: 656.397,
  y2: 757.803,
  gradientTransform: "matrix(713 0 0 -571 -466462 432833)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#f9f9f9",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#f9f9f9"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#a)",
  d: "M1921 49l-713 313.5V620h713z"
});

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1921 723"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxOTIxIDcyMyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTkyMSA3MjM7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KCS5zdDF7ZmlsbDp1cmwoI1NWR0lEXzFfKTt9Cjwvc3R5bGU+CjxnPgoJPGc+CgkJPHJlY3QgY2xhc3M9InN0MCIgd2lkdGg9IjE5MjAiIGhlaWdodD0iNzIzIi8+CgkJCgkJCTxsaW5lYXJHcmFkaWVudCBpZD0iU1ZHSURfMV8iIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iNjU2LjQyMTciIHkxPSI3NTcuMzg5NSIgeDI9IjY1Ni4zOTciIHkyPSI3NTcuODAyNiIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCg3MTMgMCAwIC01NzEgLTQ2NjQ2MiA0MzI4MzMpIj4KCQkJPHN0b3AgIG9mZnNldD0iMCIgc3R5bGU9InN0b3AtY29sb3I6I0Y5RjlGOTtzdG9wLW9wYWNpdHk6MCIvPgoJCQk8c3RvcCAgb2Zmc2V0PSIxIiBzdHlsZT0ic3RvcC1jb2xvcjojRjlGOUY5Ii8+CgkJPC9saW5lYXJHcmFkaWVudD4KCQk8cG9seWdvbiBjbGFzcz0ic3QxIiBwb2ludHM9IjE5MjEsNDkgMTIwOCwzNjIuNSAxMjA4LDYyMCAxOTIxLDYyMCAJCSIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=";
export { SvgComponent as ReactComponent };